import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const PaymentsTermEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
 

  useEffect(() => {
    axios
      .get(`/payment-terms/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.term);

        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const {
    values,
  
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      id: value.id,
      name: value.name,
      amount1: value.amount1,
      delay1: value.delay1,
      amount2: value.amount2,
      delay2: value.delay2,
    },
    enableReinitialize: true,

    onSubmit: (values, actions) => { 
         axios
        .post("/payment-terms/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Term");
          delete backendErrors['error'];
          actions.setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/payment-terms";
            }, 500);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
         
        })
        .catch((error) => {
          console.log(error)
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Payment Term Edit</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/payment-terms">Payment Terms</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Term Information </h4>
                    <form action="#" onSubmit={handleSubmit}>
                    
   
                    <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className= "form-input form-control"
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                               placeholder="Enter Payment Term Name"
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> amount1</label>
                           
                                <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount1"
                                  value={values.amount1}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Amount1" aria-label="Amount1" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">%</span>
                                  </div>
                              </div>


                           <small>
                              {backendErrors.amount1 && (
                                <span className="form-error mt-1">
                                  {backendErrors.amount1}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> delay1</label>
                             <div className="input-group">
                                  <input  type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  name="delay1"
                                  value={values.delay1}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="delay1" aria-label="delay1" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">weeks</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.delay1 && (
                                <span className="form-error mt-1">
                                  {backendErrors.delay1}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> amount2</label>
                            <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount2"
                                  value={values.amount2}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Amount2" aria-label="Amount2" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">%</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.amount2 && (
                                <span className="form-error mt-1">
                                  {backendErrors.amount2}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> delay2</label>
                            
                            <div className="input-group">
                                  <input  type="text"
                                      onKeyPress={(event) => {
                                        // Allow only numbers (0-9)
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                  name="delay2"
                                  value={values.delay2}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="delay2" aria-label="delay2" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">weeks</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.delay2 && (
                                <span className="form-error mt-1">
                                  {backendErrors.delay2}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                       
                       
                      </div>
                  

                        <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}

                          
                            </small>
                             <div className="text-end mt-4">
                                <button
                                  type="submit" id="form-submit"
                                  className="btn btn-primary"
                                  disabled={isSubmitting}
                                >
                                  Update Term
                                </button>
                              </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PaymentsTermEdit;
